import { gql } from "apollo-angular";

export const  QUOTES_FIELDS = gql`
  fragment QUOTES_FIELDS on Quotes {
    sys {
        id
    }
}`;
